/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrap-loader[_ngcontent-%COMP%]{align-items:center;background-color:#98989821;box-sizing:border-box;display:flex;height:100%;justify-content:center;left:0;top:0;position:fixed;width:100%;z-index:500000}.wrap-loader[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{color:#000;font-size:18px;font-weight:900;line-height:24px;padding-top:24px;text-align:center;margin:30px}"];
export { styles as styles };
